import { render, staticRenderFns } from "./Passo0.vue?vue&type=template&id=a35a5dcc&"
import script from "./Passo0.vue?vue&type=script&lang=js&"
export * from "./Passo0.vue?vue&type=script&lang=js&"
import style0 from "./Passo0.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports